<template>
  <div>
    <v-card class="mx-auto normal-card">
      <div class="data-table-section assignment-table">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onSortChange="onSortChange"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
            />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="text-center rescheduletest">
                  {{ item.test_name }}
                </td>
                <td class="duration-display">
                  {{ startDate(item.scheduled_start) }}
                </td>
                <td class="duration-display">{{ filterdOptions(item) }}</td>
                <td class="text-center">{{ item.subject_name }}</td>

                <td class="text-center cursor-pointer download-icon">

                 <v-img class="loader-img" src="../../../../assets/img/loading.gif" v-if="item.status == downloadStatus.IN_PROGRESS"
                    ></v-img>

                    <v-btn
                      v-else
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click="downloadTest(item)"
                    >
                    <v-img
                        width="23px"
                        src="../../../../assets/img/download.svg"
                      ></v-img>
                    </v-btn>
                  </td>
                <td v-if="item.end_time">
                  {{ startDate(item.end_time) }}
                </td>
                <td v-else>
                  <v-btn
                    v-if="checkBoostupSubscription()"
                    color="primary"
                    @click="practiceNow(item.assignment_id)"
                    class="cust-btn right-align"
                    >Practice Now
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "ImprovementAssignmentsTestsList",
  props: ["updateRouteDetails", "search"],
  async mounted() {
    this.headers = [
      {
        text: "Test Name",
        class: "",
        value: "test_name",
      },
      {
        text: "Test Date",
        class: "text-center",
        value: "test_date",
      },
      {
        text: "Test Type",
        value: "test_type",
        class: "text-center assignment-120",
        type: "multidropdown",
        options: [],
        allText: "All Test Types",
      },
      {
        text: "Subjects",
        value: "subjects",
        class: "text-center",
        hideSort: true,
      },
      { text: "", value: "", type: "blank", class: "int-120" },
      { text: "", value: "", type: "blank", class: "int-120" },
    ];
    if(!(this.user && this.user.subscription_details)){
        await this.delayTime(1000);
      }
    this.checkSessionData();
    this.downloadStatus = constants.DOWNLOAD_STATUS;
    localStorage.removeItem("prevPath");
    localStorage.setItem("prevPath", this.$route.name);
  },
  computed: {
    ...mapState("userStore", ["user",'myInstitute']),
    isOnlineInstitute(){
				return constants.institute_ids.includes(this.myInstitute.id)
			}
  },
  watch: {
    selectedExamTypes(val) {
      if (!this.isApiCall) {
        this.requestGetTestList();
      }
    },
    search(val) {
      if (!this.isApiCall) {
        this.requestGetTestList();
      }  
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      selectedExamTypes: [],
      qTypes: constants.TEST_TYPES_IT,
      cComponent:
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp",
      modalwidth: "500px",
      status: false,
      alertBoxData: {},
      isApiCall: true,
      downloadStatus: {},
      requestIds: [],
      testStatusTimeout: 0,
      toasts:{},
    };
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      improvementAssignmentList: "testStore/improvementAssignmentList",
      improvementAssignmentQueLoad: "testStore/improvementAssignmentQueLoad",
      getTestForImprovementAssignment:
        "testStore/getTestForImprovementAssignment",
      updateTestForImprovementAssignment:
        "testStore/updateTestForPracticeSession",
      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
    }),
    startDate(startDate) {
      return startDate ? moment(startDate).format("DD/MM/YYYY") : "";
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    gotoPastTest(item) {
      let test_institute_id = item.test_institute_id;
      this.$router.push({
        name: "past-test-details",
        params: {
          test_id: item.id,
          test_institute_id,
        },
      });
    },
    requestGetTestList() {
      if (this.isOnlineInstitute && !this.checkStudentUpgraded() || !this.isOnlineInstitute) {
        this.$root.showLoader = true;
        let reqData = {
          student_id: this.user.id,
          test_types: this.selectedExamTypes ? this.selectedExamTypes : [],
          sortBy: {
            order: this.orderBy.order,
            field: this.orderBy.field,
          },
          pagination: {
            page: this.currentPage,
            pageSize: this.pageSize,
          },
          searchQuery: this.search,
        };
        this.improvementAssignmentList(reqData)
          .then((response) => {
            if (
              response.list.length == 0 &&
              this.currentPage != 1 &&
              !this.$route.query.resetPage
            ) {
              this.onPageChange(1);
              return;
            }
            this.isApiCall = false;
            this.$root.showLoader = false;
            this.items = response.list;
            this.totalPages = response.pagination.pageCount;
            this.headers[2].options = this.qTypes.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = x.value;
              c.checked = this.selectedExamTypes && this.selectedExamTypes.length ? this.selectedExamTypes.includes(x.value) : false;
              return c;
            });
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
        
      }

    },
    filterdOptions(opt) {
      const optName = constants.TEST_TYPES_IT.find(
        (x) => x.id === opt.test_type
      );
      return optName.title;
    },
    onPageChange(e) {
      this.currentPage = e;
      if (!this.isApiCall) {
        this.requestGetTestList();
      }
    },
    onSortChange() {
      if (!this.isApiCall) {
        this.requestGetTestList();
      }
    },

    checkStudentUpgraded() {
      this.status = this.checkStudentUpgradedHelper(
        this.user.subscription_details
      );
      this.cComponent =
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
      (this.modalwidth = "500px"), (this.alertBoxData = {});
      return this.status;
    },
    onHeaderAction(e) {
      if (e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "test_type" && e.data && e.data.selectedItems) {
          this.selectedExamTypes = e.data.selectedItems;
          let routeName = this.$route.name;
          let crd = this.getCurrentRouteDetails(routeName);
          crd.tabDetails[crd.selectedTab].examTypes = e.data.selectedItems;
          this.setRouteDetails(crd);
          // this.onPageChange(1);
        }
    },
    practiceNow(assignmentId) {
      localStorage.removeItem("que_no");
      let reqData = {
        student_id: this.user.id,
        assignment_id: assignmentId,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      this.improvementAssignmentQueLoad(reqData)
        .then((response) => {
          localStorage.removeItem("session_start");
          localStorage.setItem("session_start", moment().format());
          this.$root.showLoader = false;
          localStorage.setItem("previousPath", this.$route.path);
          this.$router.push({
            name: "improvement-assignment-question-view",
            params: {
              improvement_assign_id: assignmentId,
              student_id: this.user.id,
            },
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onClose(data) {
      this.status = data.status;
      if (data && data.redirectTo) {
        this.redirectTo(data.redirectTo);
      }
      if (data && data.data) {
        let domainUrl = process.env.VUE_APP_API_URL;
        let tab = "offline";
        
        let token = sessionStorage.getItem("auth_token");
        let api = "download-test";
        let query = `custom=${tab}&token=${token}&column=2&isRoughWork=false&pageBreak=true`;
        if (data.download_option === 2) {
          api = "download-answer-key";
          query = `token=${token}`;
        } else if (data.download_option === 3) {
          api = "download-test-solution";
          query = `custom=${tab}&token=${token}`;
        } else if (data.download_option === 4) {
          api = "download-omr";
          query = `token=${token}`;
        }
        let url = domainUrl + `/test/${api}/${data.data.test_id}?${query}`;
        //   alert(url);
        if (data.download_option === 2) {
          window.open(url, "_blank");
        } else {
          this.downloadTestResource(
            `test/${api}/${data.data.test_id}?${query}`,
            data.data
          );
        }
        //   alert(url);
      }
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
          this.currentPage = crd.tabDetails[crd.selectedTab].page;
          this.selectedExamTypes = crd.tabDetails[crd.selectedTab].examTypes;
          this.requestIds = crd.tabDetails[crd.selectedTab].requestIds;
      }
      this.requestGetTestList();
       this.checkDownloadUpdate()
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, requestIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },

    downloadTest(item) {
      localStorage.removeItem("que_no");
      let reqData = {
        student_id: this.user.id,
        assignment_id: item.assignment_id,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      this.improvementAssignmentQueLoad(reqData)
        .then((response) => {
          // localStorage.removeItem("session_start");
          // localStorage.setItem("session_start", moment().format());
          this.$root.showLoader = false;
          // localStorage.setItem("previousPath", this.$route.path);
          // this.$router.push({
          //   name: "improvement-assignment-question-view",
          //   params: {
          //     improvement_assign_id: assignmentId,
          //     student_id: this.user.id,
          this.cComponent = "components/coordinator/Tests/DownloadTestPopup";
          this.alertBoxData = {
            ...item,
            tab: 'Online',
            isOnlineOfflineTest: false,
          };
          this.status = true;
          this.modalwidth = "550px";
          //   },
          }).catch((err) => {
          this.$root.showLoader = false;
        });
    },
    downloadTestResource(url, test) {
      this.items = this.items.map((item) => {
        if (item.test_id === test.test_id) {
          item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS;
        }
        return item;
      });
            this.toasts[test.test_id] =  this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info',duration: null})

      this.downloadTestPaper(url)
        .then((res) => {
          this.items = this.items.map((item) => {
            if (item.test_id === test.test_id) {
              item.request_id = res.request_id;
            }
            return item;
          }); // console.log(res);
          this.requestIds.push(res.request_id);
          // this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info'})
          this.$forceUpdate();

          this.checkDownloadUpdate();
          // this.requestGetTestList()
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    checkDownloadUpdate() {
      if (this.testStatusTimeout) {
			  clearInterval(this.testStatusTimeout);
		  	this.testStatusTimeout = null;
		  }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [
          constants.DOWNLOAD_TYPES.TEST_PAPER,
          constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
          constants.DOWNLOAD_TYPES.OMR,
        ],
      };
      this.getDownloadStatus(reqData)
        .then(async(res) => {
          const arr = [];
          this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if(item.url){
                arr.push({
                  url: data.url,
                  request_id: data.request_id
                })
              }
              // this.downloadTestURL(item)
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );
              // console.log(item,"item value : ")
              this.toasts[item?.test_id]?.goAway(0);
              delete this.toasts[item?.test_id];
              this.$toasted.success(`Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,{icon: 'info'})
            }
          });
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item);
            
           await new Promise(resolve => {
            console.log('Starting delay');
            setTimeout(() => {
              resolve();
              }, 1000);
            });
          }
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {
       });
    },
    downloadTestURL(item) {

      if (item.url && item.request_id) {
        window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };
        
       this.items=this.items.map((e)=>{
        if(e.request_id== item.request_id) {
          e.status= constants.DOWNLOAD_STATUS.COMPLETED
        }
        return e
        })
        // item.status = null;
        // item.request_id = null;
        // item.url = null;
        setTimeout(() => {
          this.deleteDownloadData(reqData)
            .then((res) => {
            })
            .catch((err) => {});
        }, 5000);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.testStatusTimeout);
    this.testStatusTimeout = null;
  }
  
};
</script>